import React from 'react'

import styles from './Price.module.css'

interface PriceProps {
  amount: string
  discount?: string
}

const Price = ({ amount, discount }: PriceProps): JSX.Element => {
  if (discount) {
    return (
      <div className={styles.priceWrapper}>
        <div className={styles.originalPrice}>{amount}</div>
        <br />
        <div className={styles.discountedPrice}>{discount}</div>
      </div>
    )
  }
  return (
    <div className={styles.priceWrapper}>
      <div className={styles.price}>{amount}</div>
    </div>
  )
}

export default Price
